// TD-2576 — a click inside the mobile bottom action bar or any of its sheets
// (the results bar itself, the "More" sheet, or a View/Sort/Customize/Download
// MobileSheet) must NOT count as an outside-click for the desktop-era dropdown
// close handlers on the Search and saved-project results surfaces. The bar is
// portaled to <body> and the sheets live in the top layer, so none of them match
// the old anchored-dropdown / trigger selectors: without this exemption the tap
// that opens a menu — or the ✕ / backdrop that should close a sheet — is read as
// "outside" and toggles the flag a second time (this is what left the Download
// sheet un-dismissable on touch). Since TD-2772 the "More" sheet is a
// `MobileSheet` too, so `.mobile-sheet` covers every sheet the bar can open.
export const isInsideResultsMobileBar = (target) =>
  !!target?.closest?.('.results-mobile-action-bar') || !!target?.closest?.('.mobile-sheet');

/**
 * Height in px the fixed results bar occupies at the bottom of the viewport, or 0
 * when it isn't there. Use it to keep viewport-positioned overlays (e.g. the heatmap
 * tile context menu) clear of the bar.
 *
 * Measured rather than read from a constant on purpose: the bar is CSS-gated per
 * surface (`--to-833` on Search, `--to-1200` on Projects/Team), so a hidden bar
 * reports `offsetHeight === 0` and this self-gates by breakpoint and by surface with
 * nothing to keep in sync. `offsetHeight` also already includes the bottom
 * safe-area inset the bar pads itself with. TD-2772.
 */
export const getResultsMobileBarInset = () => {
  if (typeof document === 'undefined') return 0;
  const bar = document.querySelector('.results-mobile-action-bar');
  return bar?.offsetHeight || 0;
};
